export default "__VITE_ASSET__DLorFkZM__"